/**
 * @author Valerio Chiodino <valerio.chiodino@openmindonline.it>
 * @copyright Openmind S.r.l. 2017
 *
 * This component switches labels based on class the element recieves.
 *
 * Data options:
 *
 * data-label           string - the class that triggers the changes.
 * data-label-*         string - when the label receive "*" class, this text is used.
 * data-label-not-*     string - when the "*" is removed from label, this text is used.
 * data-label-container string - the container to use for the text.
 *
 * Notes:
 * - If one of 'data-label-*' or 'data-label-not-*' is not provided, than the original text is used.
 */

(function($, App, Utils, Components) {
  'use strict';

  var logger = new Logger('DataLabel');

  Components.create('DataLabel', {
    /**
     * Bind specific events and objects.
     */
    bindEvents: function() {
      $('*[data-label]')
        .not('*[data-label=""]')
        .off('class:changed')
        .on('class:changed', function(e, cssClasses, toggle) {
          var self = $(this);

          if (cssClasses.indexOf(self.data('label')) == -1) {
            return;
          }

          var labelContainer = self.data('labelContainer'),
            labelEl = labelContainer ? self.find(labelContainer) : self;

          $(cssClasses.split(' ')).each(function(i, cssClass) {
            var dataPart = Utils.Inflector.camelize(cssClass),
              label = self.data('label' + dataPart),
              dStore = 'labelOriginalText' + dataPart,
              originalText = self.data(dStore);

            if (!originalText) {
              originalText = labelEl.text();
              self.data(dStore, originalText);
            }

            if (!toggle) {
              logger.d(`Removed ${cssClass} class from label`);
              label = self.data('labelNot' + dataPart);
            }

            if (!label) {
              label = originalText;
            }

            labelEl.text(label);
          });
        });
    },

    /**
     * Initializes the component.
     */
    init: function() {
      Components.DataLabel.bindEvents();
    }
  });
})(jQuery, window.App, window.App.Utils, window.App.Components);
